import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSnapshot } from "../lib/api";
import KatlasProofCard from "../components/KatlasProofCard";
import EvidencePack from "../components/EvidencePack";
import ReadinessDiagnostic from "../components/ReadinessDiagnostic";

export default function Snapshot() {
    const { token } = useParams();
    const [run, setRun] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        getSnapshot(token)
            .then(setRun)
            .catch(() => setErr("Snapshot not found"));
    }, [token]);

    if (err)
        return (
            <div className="max-w-3xl mx-auto px-6 py-24 text-slate-500" data-testid="snapshot-error">
                {err}
            </div>
        );
    if (!run)
        return (
            <div className="max-w-3xl mx-auto px-6 py-24 text-slate-500">
                Loading snapshot…
            </div>
        );

    return (
        <div data-testid="snapshot-page">
            <section className="border-b border-slate-200 bg-slate-50/60">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-12 pb-10">
                    <div className="overline mb-2">Read-only customer snapshot</div>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight max-w-3xl">
                        {run.scenario_title}
                    </h1>
                    <p className="mt-4 text-base text-slate-700 max-w-3xl leading-relaxed">
                        Decision: <strong>{run.decision?.decision_label}</strong> —
                        authorised by {run.decision?.accountable_role}.
                    </p>
                    {run.sector && (
                        <p
                            className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500"
                            data-testid="snapshot-sector"
                        >
                            Sector preset · {run.sector.label}
                        </p>
                    )}
                </div>
            </section>
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 space-y-8">
                {run.receipt && <KatlasProofCard receipt={run.receipt} />}
                {run.evidence_pack && <EvidencePack run={run} />}
                <ReadinessDiagnostic
                    categories={Object.keys(run.diagnostic || {}).map((k) => ({
                        key: k,
                        label: k.replace(/_/g, " "),
                    }))}
                    values={run.diagnostic}
                    readOnly
                />
            </div>
        </div>
    );
}
